import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index'
import paperRevision from '@/pages/paper-revision' //论文修改
import chSystem from '@/pages/ch-system' //论文查重
import chSystemDetail from '@/pages/ch-system-detail' //论文查重详情
import reportDownload from '@/pages/ch-report-download' //论文查重报告下载
import newsList from '@/pages/news-list' //知网查重咨询列表
import newsListDetail from '@/pages/news-list-detail' //知网查重咨询详情
import descriptionFirst from '@/pages/description-first' //知网查重系统
import descriptionSecond from '@/pages/description-second' //论文查重流程
import descriptionThird from '@/pages/description-third' //论文FQA
import paperUpload from '@/pages/paper-upload' //上传论文
import payPage from '@/pages/pay-page' //支付页面

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/paperRevision/',
      name: 'paperRevision',
      component: paperRevision
    },
    {
      path: '/chSystem/',
      name: 'chSystem',
      component: chSystem
    },
    {
      path: '/chSystemDetail/',
      name: 'chSystemDetail',
      component: chSystemDetail
    },
    {
      path: '/reportDownload/',
      name: 'reportDownload',
      component: reportDownload
    },
    {
      path: '/newsList',
      name: 'newsList',
      component: newsList
    },
    {
      path: '/newsListDetail',
      name: 'newsListDetail',
      component: newsListDetail
    },
    {
      path: '/descriptionFirst/',
      name: 'descriptionFirst',
      component: descriptionFirst
    },
    {
      path: '/descriptionSecond/',
      name: 'descriptionSecond',
      component: descriptionSecond
    },
    {
      path: '/descriptionThird/',
      name: 'descriptionThird',
      component: descriptionThird
    },
    {
      path: '/paperUpload/',
      name: 'paperUpload',
      component: paperUpload
    },
    {
      path: '/payPage/',
      name: 'payPage',
      component: payPage
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js